import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, CheckCircle2 } from "lucide-react";
import api from "../../lib/api";
import { AdminHeader, Btn, DataTable } from "../../components/admin/Fields";

const AdminContactSubmissionsPage = () => {
  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);
  const load = () => api.get("/admin/contact-submissions").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const toggleHandled = async (r) => {
    await api.put(`/admin/contact-submissions/${r.id}`, { handled: !r.handled });
    load();
  };
  const remove = async (r) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/contact-submissions/${r.id}`);
    setSelected(null); load();
  };

  return (
    <div data-testid="admin-contact-page">
      <AdminHeader eyebrow="Inbox" title="İletişim Formları" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7">
          <DataTable
            columns={[
              { key: "handled", label: "", render: (r) => <span className={`inline-block w-2 h-2 rounded-full ${r.handled ? "bg-brand-medium" : "bg-brand-gold"}`} /> },
              { key: "name", label: "Ad" },
              { key: "email", label: "Email" },
              { key: "subject", label: "Konu" },
              { key: "created_at", label: "Tarih", render: (r) => (r.created_at || "").substring(0, 10) },
            ]}
            rows={rows}
            onRowClick={(r) => setSelected(r)}
          />
        </div>
        <div className="lg:col-span-5">
          {selected ? (
            <div className="bg-white border border-black/5 p-6 md:p-8 sticky top-6" data-testid="contact-detail">
              <div className="text-[0.66rem] tracking-[0.28em] uppercase text-brand-medium">{selected.created_at?.substring(0, 10)}</div>
              <div className="font-serif text-2xl text-brand-navy mt-2">{selected.subject || "—"}</div>
              <div className="mt-2 text-sm text-brand-medium">
                <span className="text-brand-dark">{selected.name}</span> · <a href={`mailto:${selected.email}`}>{selected.email}</a>
                {selected.phone ? <> · {selected.phone}</> : null}
              </div>
              <div className="mt-6 text-brand-dark whitespace-pre-line leading-relaxed">{selected.message}</div>
              <div className="mt-8 flex gap-3">
                <Btn onClick={() => toggleHandled(selected)}><CheckCircle2 size={14} /> {selected.handled ? "Okunmadı işaretle" : "İşlendi olarak işaretle"}</Btn>
                <Btn variant="danger" onClick={() => remove(selected)}><Trash2 size={14} /> Sil</Btn>
              </div>
            </div>
          ) : (
            <div className="bg-white border border-black/5 p-6 md:p-8 text-brand-medium">Bir mesaj seçin.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminContactSubmissionsPage;
